import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import styles from "./ViewAppPage.module.scss";
import TabbedFormLayout from "../../components/TabbedFormLayout/TabbedFormLayout";

interface App {
  id: string;
  name: string;
  description?: string;
  isActive?: boolean;
  organizationId?: string;
  createdBy?: string;
  createdAt?: string;
}

export default function ViewAppPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [appData, setAppData] = useState<App>({
    id: "",
    name: "",
    description: "",
    isActive: true,
    organizationId: "",
    createdBy: "",
    createdAt: "",
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const fetchApp = async () => {
    try {
      const res = await api.post("/core/app/get", { appId: id });
      if (!res.data) {
        throw new Error("No app data returned");
      }
      setAppData(res.data);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to load app data";
      console.error("Failed to fetch app:", err);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchApp();
  }, [id]);

  if (loading) return <div className={styles.loading}>Loading...</div>;
  if (error) return <div className={styles.error}>{error}</div>;

  const tabs = [
    {
      label: "Details",
      content: (
        <div className={styles.tabContent}>
          <div className={styles.row}>
            <span className={styles.label}>Name</span>
            <span className={styles.value}>{appData.name || "—"}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Description</span>
            <span className={styles.value}>{appData.description || "—"}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Active</span>
            <span className={styles.value}>
              {appData.isActive === undefined ? "—" : appData.isActive ? "Yes" : "No"}
            </span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Organization ID</span>
            <span className={styles.value}>{appData.organizationId || "—"}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Created By</span>
            <span className={styles.value}>{appData.createdBy || "—"}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Created At</span>
            <span className={styles.value}>
              {appData.createdAt ? new Date(appData.createdAt).toLocaleString() : "—"}
            </span>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.title}>View App: {appData.name || "Loading..."}</div>
      <TabbedFormLayout
        tabs={tabs}
        onSave={() => {}}
        onCancel={() => navigate("/apps")}
        showActions={false}
      />
    </div>
  );
}
